import { useEffect } from "react";
import Sidebar from "../components/chat/Sidebar";
import ChatWindow from "../components/chat/ChatWindow";
import WelcomeScreen from "../components/chat/WelcomeScreen";
import useChatStore from "../store/chatStore";
import styles from "./ChatPage.module.css";

const ChatPage = () => {
  const { activeConversation, fetchConversations } = useChatStore();

  useEffect(() => {
    fetchConversations();
    const onFocus = () => fetchConversations();
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, []);

  // On mobile — back button goes back to sidebar
  const handleBack = () => {
    useChatStore.getState().activeConversation && 
    useChatStore.setState({ activeConversation: null, messages: [] });
  };

  return (
    <div className={styles.chatPage}>
      {/* On mobile: show sidebar only if no active conversation */}
      <div className={`${styles.sidebarPane} ${activeConversation ? styles.sidebarHidden : styles.sidebarVisible}`}>
        <Sidebar />
      </div>

      {/* On mobile: show chat only if active conversation */}
      <main className={`${styles.main} ${activeConversation ? styles.mainVisible : styles.mainHidden}`}>
        {activeConversation
          ? <ChatWindow onBack={handleBack} />
          : <WelcomeScreen />
        }
      </main>
    </div>
  );
};

export default ChatPage;
